import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import _defineProperty from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/defineProperty";
import _typeof from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/typeof";
import "core-js/modules/es6.array.sort";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Papa from "papaparse";
import SessionStorage from 'quasar/src/plugins/SessionStorage.js';;
import * as Helpers from "../../helpers";
export default {
  name: "grid",
  props: {
    frozenHeaders: {
      default: true
    },
    defaultedShowRows: {
      default: true
    },
    propertyId: null,
    allowShowHide: {
      default: false
    },
    newDisable: {
      default: false
    },
    newHint: {
      default: false
    },
    newHintLabel: {
      default: ""
    },
    tableData: {},
    columns: {},
    image: {},
    input: {},
    visibleColumns: {},
    selectOptions: {},
    selectedFilter: {},
    select: {},
    allowExport: {
      type: Boolean,
      default: true
    },
    allowFullscreen: {
      type: Boolean,
      default: true
    },
    allowNew: {},
    allowSelectFilter: {},
    allowSearch: {},
    allowUpload: {},
    allowAutoIncrease: {},
    exportOptions: {},
    hideHeader: {},
    showOptions: {},
    tableTitle: {},
    hideBottom: {},
    customfooter: {
      default: false,
      type: Boolean
    },
    tableStyle: {},
    fullscreen: false,
    rowKey: {},
    wrapCells: {
      type: Boolean,
      default: true
    },
    newIcon: {
      type: String,
      default: "fas fa-plus"
    },
    initialDropDown: {},
    allowCSVTemplate: {},
    templateColumns: {},
    allowImportCSV: {},
    templateData: {},
    btmColAlignment: {
      default: "right"
    },
    btmRowVisible: {},
    btmRowContent1: {},
    btmRowContent2: {},
    btmRowContent3: {},
    btmRowContent4: {},
    btmRowContent5: {},
    btmRowContent6: {},
    btmRowContent7: {},
    btmRowContent8: {},
    btmColSpan: {},
    btmColSpan2: {},
    btmRowShow2ndCol: {},
    btmColSpan3: {},
    btmRowShow3rdCol: {},
    btmColSpan4: {},
    btmRowShow4thCol: {},
    btmColSpan5: {},
    btmRowShow5thCol: {},
    btmColSpan6: {},
    btmRowShow6thCol: {},
    btmColSpan7: {},
    btmRowShow7thCol: {},
    btmColSpan8: {},
    btmRowShow8thCol: {},
    enableAlphaSort: {},
    disableViewAll: {
      default: false,
      type: Boolean
    },
    alphaSortColumName: {},
    useInput: {},
    dropdownSelectFilterColumn: {},
    pagination: {
      default: function _default() {
        return {
          page: 1,
          rowsPerPage: 0,
          sortBy: "name",
          descending: false
        };
      }
    },
    loading: {},
    subFilterColumn: {},
    dropdownLabel: {},
    newLabel: {
      type: String,
      default: "Add"
    },
    newColor: {
      default: "positive"
    },
    noDataLabel: {},
    dense: {
      type: Boolean,
      default: true
    },
    disableAutoFilter: {
      type: Boolean,
      default: false
    },
    editting: {
      type: Boolean,
      default: false
    },
    allowEdit: {
      type: Boolean,
      default: false
    },
    rowClass: {
      type: Function,
      default: function _default(row) {
        return "";
      }
    },
    filterColumn: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      alphaSortFilter: null,
      selectFilter: null,
      filter: null,
      show: this.defaultedShowRows,
      internalLoading: true,
      internalPagination: {
        page: 1,
        rowsPerPage: 0,
        sortBy: "name",
        descending: false
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.selectFilter = this.initialDropDown;
    var lastFilter = this.getFilter();
    setTimeout(function () {
      _this.internalLoading = false;
    }, 1000);
  },
  computed: {
    passedInPagination: {
      get: function get() {
        if (typeof this.pagination !== "undefined") return this.pagination;else return this.internalPagination;
      },
      set: function set(v) {
        this.internalPagination = v;
        this.$emit("setPagination", v);
      }
    },
    sortedItems: function sortedItems() {
      var me = this;
      if (me.alphaSortColumName) return this.tableData.sort(function (a, b) {
        var nameA = a[me.alphaSortColumName].toUpperCase(); // ignore upper and lowercase

        var nameB = b[me.alphaSortColumName].toUpperCase(); // ignore upper and lowercase

        if (nameA < nameB) {
          return -1;
        }

        if (nameA > nameB) {
          return 1;
        } // names must be equal


        return 0;
      });
      return [];
    },
    groupByAlphabet: function groupByAlphabet() {
      var groupedNames = {};
      var opt = ["#", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];

      for (var _i = 0, _opt = opt; _i < _opt.length; _i++) {
        var item = _opt[_i];
        groupedNames[item] = item[0];
      }

      return groupedNames;
    },
    displayData: function displayData() {
      var _this2 = this;

      if (this.disableAutoFilter) {
        return this.tableData;
      }

      if (this.enableAlphaSort) {
        //condition 1 only alpha sort filter, no select filter and no search filter
        if (this.alphaSortFilter && !this.filter && !this.selectFilter) {
          if (this.alphaSortFilter == "View All") return this.tableData;else if (this.alphaSortFilter == "#") return this.tableData.filter(function (item, index) {
            return item[_this2.alphaSortColumName] != null && item[_this2.alphaSortColumName].charAt(0) >= "0" && item[_this2.alphaSortColumName].charAt(0) <= "9";
          });else return this.tableData.filter(function (item, index) {
            return item[_this2.alphaSortColumName] != null && item[_this2.alphaSortColumName].charAt(0) == _this2.alphaSortFilter;
          });
        } //condition 2 alpha sort filter with select filter
        else if (this.alphaSortFilter && !this.filter && this.selectFilter && this.alphaSortFilter != "View All" && this.alphaSortFilter != "#") {
            if (typeof this.selectFilter == "string") {
              return this.tableData.filter(function (v) {
                return v[_this2.dropdownSelectFilterColumn].toLowerCase() == _this2.selectFilter.toLowerCase() && v[_this2.alphaSortColumName] != null && v[_this2.alphaSortColumName].charAt(0) == _this2.alphaSortFilter;
              });
            } else if (_typeof(this.selectFilter) == "object" && this.selectFilter.value > -1) {
              if (this.selectFilter.selectSubFilter && _typeof(this.selectFilter.selectSubFilter) == "object") {
                return this.tableData.filter(function (v) {
                  return v[_this2.alphaSortColumName] != null && v[_this2.dropdownSelectFilterColumn] == _this2.selectFilter.value && v[_this2.alphaSortColumName].charAt(0) == _this2.alphaSortFilter && v[_this2.subFilterColumn] == _this2.selectFilter.selectSubFilter.value;
                });
              } else if (this.selectFilter.selectSubFilter && (typeof this.selectFilter.selectSubFilter == "string" || typeof this.selectFilter.selectSubFilter == "number")) {
                return this.tableData.filter(function (v) {
                  return v[_this2.alphaSortColumName] != null && v[_this2.dropdownSelectFilterColumn] == _this2.selectFilter.value && v[_this2.alphaSortColumName].charAt(0) == _this2.alphaSortFilter && v[_this2.subFilterColumn] == _this2.selectFilter.selectSubFilter;
                });
              } else return this.tableData.filter(function (v) {
                return v[_this2.alphaSortColumName] != null && v[_this2.dropdownSelectFilterColumn] == _this2.selectFilter.value && v[_this2.alphaSortColumName].charAt(0) == _this2.alphaSortFilter;
              });
            }
          } //condition 3 alpha sort with select fiter and search filter
          else if (this.alphaSortFilter && this.filter && this.selectFilter && this.alphaSortFilter != "View All" && this.alphaSortFilter != "#") {
              if (typeof this.selectFilter == "string") {
                return this.tableData.filter(function (v) {
                  return v[_this2.dropdownSelectFilterColumn] != null && v[_this2.alphaSortColumName] != null && v[_this2.dropdownSelectFilterColumn].toLowerCase() == _this2.selectFilter.toLowerCase() && v[_this2.alphaSortColumName].charAt(0) == _this2.alphaSortFilter && v[_this2.alphaSortColumName].toLowerCase().indexOf(_this2.filter.toLowerCase()) > -1;
                });
              } else if (_typeof(this.selectFilter) == "object" && this.selectFilter.value > -1) {
                if (this.selectFilter.selectSubFilter && _typeof(this.selectFilter.selectSubFilter) == "object") {
                  return this.tableData.filter(function (v) {
                    return v[_this2.alphaSortColumName] != null && v[_this2.dropdownSelectFilterColumn] == _this2.selectFilter.value && v[_this2.alphaSortColumName].charAt(0) == _this2.alphaSortFilter && v[_this2.subFilterColumn] == _this2.selectFilter.selectSubFilter.value && v[_this2.alphaSortColumName].toLowerCase().indexOf(_this2.filter.toLowerCase()) > -1;
                  });
                } else if (this.selectFilter.selectSubFilter && (typeof this.selectFilter.selectSubFilter == "string" || typeof this.selectFilter.selectSubFilter == "number")) {
                  return this.tableData.filter(function (v) {
                    return v[_this2.alphaSortColumName] != null && v[_this2.dropdownSelectFilterColumn] == _this2.selectFilter.value && v[_this2.alphaSortColumName].charAt(0) == _this2.alphaSortFilter && v[_this2.subFilterColumn] == _this2.selectFilter.selectSubFilter && v[_this2.alphaSortColumName].toLowerCase().indexOf(_this2.filter.toLowerCase()) > -1;
                  });
                } else return this.tableData.filter(function (v) {
                  return v[_this2.alphaSortColumName] != null && v[_this2.dropdownSelectFilterColumn] == _this2.selectFilter.value && v[_this2.alphaSortColumName].charAt(0) == _this2.alphaSortFilter && v[_this2.alphaSortColumName].toLowerCase().indexOf(_this2.filter.toLowerCase()) > -1;
                });
              }
            } //condition 4 alpha sort enabaled but no alpha sort selected with select filter and no search filter
            else if (this.selectFilter && !this.filter) {
                if (typeof this.selectFilter == "string") {
                  return this.tableData.filter(function (v) {
                    return v[_this2.dropdownSelectFilterColumn] != null && v[_this2.dropdownSelectFilterColumn].toLowerCase() == _this2.selectFilter.toLowerCase();
                  });
                } else if (_typeof(this.selectFilter) == "object" && this.selectFilter.value > -1) {
                  if (this.selectFilter.selectSubFilter && _typeof(this.selectFilter.selectSubFilter) == "object") {
                    return this.tableData.filter(function (v) {
                      return v[_this2.dropdownSelectFilterColumn] == _this2.selectFilter.value && v[_this2.subFilterColumn] == _this2.selectFilter.selectSubFilter.value;
                    });
                  } else if (this.selectFilter.selectSubFilter && (typeof this.selectFilter.selectSubFilter == "string" || typeof this.selectFilter.selectSubFilter == "number")) {
                    return this.tableData.filter(function (v) {
                      return v[_this2.dropdownSelectFilterColumn] == _this2.selectFilter.value && v[_this2.subFilterColumn] == _this2.selectFilter.selectSubFilter;
                    });
                  } else return this.tableData.filter(function (v) {
                    return v[_this2.dropdownSelectFilterColumn] == _this2.selectFilter.value;
                  });
                }
              } //condition 5 alpha sort enabaled but no alpha sort selected with search filter and select filter
              else if (this.selectFilter && this.filter) {
                  if (typeof this.selectFilter == "string") {
                    return this.tableData.filter(function (v) {
                      return v[_this2.dropdownSelectFilterColumn] != null && v[_this2.alphaSortColumName] != null && v[_this2.dropdownSelectFilterColumn].toLowerCase() == _this2.selectFilter.toLowerCase() && v[_this2.alphaSortColumName].toLowerCase().indexOf(_this2.filter.toLowerCase()) > -1;
                    });
                  } else if (_typeof(this.selectFilter) == "object" && this.selectFilter.value > -1) {
                    if (this.selectFilter.selectSubFilter && _typeof(this.selectFilter.selectSubFilter) == "object") {
                      return this.tableData.filter(function (v) {
                        return v[_this2.alphaSortColumName] != null && v[_this2.dropdownSelectFilterColumn] == _this2.selectFilter.value && v[_this2.subFilterColumn] == _this2.selectFilter.selectSubFilter.value && v[_this2.alphaSortColumName].toLowerCase().indexOf(_this2.filter.toLowerCase()) > -1;
                      });
                    } else if (this.selectFilter.selectSubFilter && (typeof this.selectFilter.selectSubFilter == "string" || typeof this.selectFilter.selectSubFilter == "number")) {
                      return this.tableData.filter(function (v) {
                        return v[_this2.alphaSortColumName] != null && v[_this2.dropdownSelectFilterColumn] == _this2.selectFilter.value && v[_this2.subFilterColumn] == _this2.selectFilter.selectSubFilter && v[_this2.alphaSortColumName].toLowerCase().indexOf(_this2.filter.toLowerCase()) > -1;
                      });
                    } else return this.tableData.filter(function (v) {
                      return v[_this2.alphaSortColumName] != null && v[_this2.dropdownSelectFilterColumn] == _this2.selectFilter.value && v[_this2.alphaSortColumName].toLowerCase().indexOf(_this2.filter.toLowerCase()) > -1;
                    });
                  }
                } //condition 6 alpha sort enabaled with search filter and no select filter
                else if (this.filter && !this.selectFilter) {
                    if (this.alphaSortFilter == "View All" || !this.alphaSortFilter) return this.tableData;else if (this.alphaSortFilter == "#") return this.tableData.filter(function (item, index) {
                      return item[_this2.alphaSortColumName] != null && item[_this2.alphaSortColumName].charAt(0) >= "0" && item[_this2.alphaSortColumName].charAt(0) <= "9";
                    });else return this.tableData.filter(function (item, index) {
                      return item[_this2.alphaSortColumName] != null && item[_this2.alphaSortColumName].charAt(0) == _this2.alphaSortFilter;
                    });
                  } else return this.tableData;
      } else if (this.selectFilter && this.dropdownSelectFilterColumn) {
        if (typeof this.selectFilter == "string") {
          return this.tableData.filter(function (v) {
            return v[_this2.dropdownSelectFilterColumn] != null && v[_this2.dropdownSelectFilterColumn].toLowerCase() == _this2.selectFilter.toLowerCase();
          });
        } else if (_typeof(this.selectFilter) == "object" && this.selectFilter.value > -1) {
          return this.tableData.filter(function (v) {
            return v[_this2.dropdownSelectFilterColumn] == _this2.selectFilter.value;
          });
        }
      }

      return this.tableData;
    },
    displayColumns: function displayColumns() {
      var _this3 = this;

      return this.columns.map(function (x) {
        return _objectSpread({}, x, {
          format: typeof x.format === "string" ? _this3.getFormat(x.format) : x.format
        });
      });
    }
  },
  methods: {
    getFormat: function getFormat(type) {
      switch (type.toLowerCase()) {
        case "money":
          return Helpers.MoneyHelper.GetMoneyReadValue;

        case "date":
          return Helpers.DateHelper.getFriendlyDateAllowNull;
      }
    },
    defaultFilter: function defaultFilter(rows, terms) {
      var cols = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.computedCols;
      var cellValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.getCellValue;
      var lowerTerms = terms ? terms.toLowerCase() : "";
      return rows.filter(function (row) {
        return cols.some(function (col) {
          return (cellValue(col, row) + "").toLowerCase().indexOf(lowerTerms) !== -1;
        });
      });
    },
    slotVal: function slotVal(name) {
      return "body-cell-" + name;
    },
    filterItems: function filterItems(rows, terms, cols, getCellValue) {
      var _this4 = this;

      return rows.filter(function (x) {
        return x[_this4.filterColumn].toLowerCase().indexOf(terms.toLowerCase()) > -1;
      });
    },
    exportGridToCSV: function exportGridToCSV() {
      var _this5 = this;

      var columns = this.columns;
      if (this.visibleColumns) columns = this.columns.filter(function (y) {
        return (y.custom != true || y.exportCustom == true) && y.donotexport != true && _this5.visibleColumns.find(function (x) {
          return y.name == x;
        });
      });
      var dataSet = []; //go through each row of data from props.tableData and assemble the new csv line

      this.displayData.forEach(function (row) {
        var data = [];
        columns.forEach(function (col) {
          data.push(_this5.getCellValue(col, row));
        }); //add csv row to the dataSet

        dataSet.push(data);
      }); //parse into csv string

      var textString = Papa.unparse({
        fields: columns.map(function (x) {
          return x.label;
        }),
        data: dataSet,
        quotes: true,
        quoteChar: '"""',
        delimiter: ",",
        escapeChar: '"'
      });
      this.downloadCSV(textString.replace(/,"""/g, ',"=""').replace(/^"""/gm, '"=""'));
    },
    downloadCSV: function downloadCSV(csv) {
      var data, filename, link;
      if (csv == null) return;
      filename = (this.exportOptions && this.exportOptions.filename ? this.exportOptions.filename : "export") + ".csv";
      var blob = new Blob([csv], {
        type: "text/csv;charset=utf-8;"
      });

      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, filename);
      } else {
        var link = document.createElement("a");

        if (link.download !== undefined) {
          // feature detection, Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", filename);
          link.style = "visibility:hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    },
    downloadCSVTemplate: function downloadCSVTemplate() {
      var dataSet = [];
      var columns = this.templateColumns.filter(function (x) {
        return x != "Actions" && x != "Image";
      }).map(function (name) {
        return name;
      });

      if (this.templateData.length > 0) {
        this.templateData.forEach(function (data) {
          var rowSet = [];
          Object.keys(data).forEach(function (key) {
            columns.forEach(function (col) {
              if (key.toLowerCase() == col.toLowerCase()) {
                rowSet.push(data[key]);
              }
            });
          });
          dataSet.push(rowSet);
        });
      } //parse into csv string


      var textString = Papa.unparse({
        fields: columns,
        data: dataSet
      });
      this.downloadCSV(textString);
    },
    importCSV: function () {
      var _importCSV = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(evt) {
        var me, f, data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                me = this;
                f = evt.target.files[0];
                _context.next = 4;
                return Papa.parse(f, {
                  header: true,
                  download: true,
                  dynamicTyping: true,
                  complete: function complete(results) {
                    data = results.data;
                    me.$emit("processImportData", data);
                  }
                });

              case 4:
                this.$refs.fileInput.value = "";

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function importCSV(_x) {
        return _importCSV.apply(this, arguments);
      }

      return importCSV;
    }(),
    triggerFileInput: function triggerFileInput() {
      this.$refs.fileInput.click();
    },
    goToLetter: function goToLetter(letter, event) {
      this.alphaSortFilter = letter;
      this.$emit("alphaFilter", {
        alphaSortFilter: this.alphaSortFilter,
        selectFilter: this.selectFilter
      });
    },
    request: function request(props) {
      props.selectFilter = this.selectFilter;
      this.$emit("request", props);
    },
    subFilterChange: function subFilterChange($event) {
      this.$emit("subFilter", this.selectFilter);
    },
    filterChange: function filterChange() {
      this.$emit("filter", this.selectFilter);
    },
    getCellValue: function getCellValue(col, row) {
      var val = typeof col.field === "function" ? col.field(row) : row[col.field];
      return col.format !== void 0 ? col.format(val, row) : val;
    },
    print: function print() {
      window.print();
    },
    emitFilter: function emitFilter($event) {
      this.$emit("filter", $event);
    },
    saveFilter: function saveFilter(filter) {
      return SessionStorage.set(this.$router.currentRoute.path, filter);
    },
    getFilter: function getFilter() {
      return SessionStorage.getItem(this.$router.currentRoute.path);
    }
  },
  watch: {
    selectOptions: function selectOptions() {
      var lastFilter = this.getFilter();

      if (lastFilter) {
        lastFilter.selectedSubFilter = lastFilter.subFilter;
        this.selectFilter = lastFilter;
        this.emitFilter(lastFilter);
        this.$emit("subFilter", lastFilter.selectSubFilter);
      }
    },
    selectFilter: {
      deep: true,
      handler: function handler() {
        if (!this.internalLoading) this.saveFilter(this.selectFilter);
      }
    }
  }
};